import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { MainContent } from 'src/layouts/main';
import { useRouter } from 'src/routes/hooks';

import { Iconify } from 'src/components/iconify';
import { Image } from 'src/components/image';
import { paths } from 'src/routes/paths';
import { CONFIG } from 'src/config-global';

export default function BookingSuccessView() {
  const router = useRouter();
  return (
    <MainContent>
      <Container>
        <Box
          sx={{
            py: 8,
            maxWidth: 480,
            mx: 'auto',
            textAlign: 'center',
          }}
        >
          <Box
            component="img"
            src="/assets/images/mockups/app.png"
            sx={{
              width: { xs: 240, md: 360 },
              height: { xs: 240, md: 360 },
              mx: 'auto',
              mb: 5,
            }}
          />

          <Box sx={{ pb: 2, textAlign: 'center' }}>
            <Image
              height={32}
              src="/logo/logo-full.svg"
              alt="Spark Logo"
              sx={{
                mx: 'auto',
                '& img': {
                  objectFit: 'contain',
                  width: 'auto',
                  height: '100%',
                },
              }}
            />
          </Box>

          <Typography
            variant="h3"
            sx={{ mb: 2 }}
            className="font-spark-primary"
          >
            Booking Successful!
          </Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 5 }}>
            Your booking has been confirmed. Download the Spark app to view all
            your bookings and get instant updates.
          </Typography>

          <Stack
            spacing={2}
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="center"
          >
            <Button
              variant="contained"
              startIcon={<Iconify icon="ri:google-play-fill" />}
              href={CONFIG.site.appStore.googlePlay}
              target="_blank"
              rel="noopener"
            >
              Get it on Play Store
            </Button>

            <Button
              variant="contained"
              startIcon={<Iconify icon="ri:app-store-fill" />}
              href={CONFIG.site.appStore.appleAppStore}
              target="_blank"
              rel="noopener"
            >
              Download on App Store
            </Button>
          </Stack>

          <Button
            color="primary"
            variant="outlined"
            sx={{ mt: 5 }}
            onClick={() => router.push(paths.tenant.root)}
          >
            Explore More Experiences
          </Button>
        </Box>
      </Container>
    </MainContent>
  );
}
